import { render, staticRenderFns } from "./DiagnosticHistoryInfoItem.vue?vue&type=template&id=d1aa17b8&"
import script from "./DiagnosticHistoryInfoItem.vue?vue&type=script&lang=js&"
export * from "./DiagnosticHistoryInfoItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports